import React from 'react';

import Button from '@pb/kit-component-button';
import {Group, Item} from '@pb/kit-component-group';
import Loading, {Types} from '@pb/kit-component-loading';

type Props = {
    isLoading: boolean,
    onClick: () => void,
    generatedResult: string,
};

export const ContractsGenerationView = (props: Props) => {
    const {
        isLoading,
        onClick,
        generatedResult,
    } = props;

    return (
        <Group direction="v" gap="xxl" className="pt-xxl">
            <Group>
                <Button onClick={onClick} variant="Type.PRIMARY" disabled={isLoading}>Generate Contracts</Button>
                <Item>
                    {isLoading ? <Loading fast={true} type={Types.ICON}/> : <span>{generatedResult}</span>}
                </Item>
            </Group>
        </Group>
    );
};
